function setCookie(name,value,days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}
function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
}

// Example
var cookieVal = getCookie('musikdk-preloader');
var preloader = document.getElementById('preloader');
var pageContent = document.getElementById('pagecontent');

if (cookieVal !== 'seen') {

	document.addEventListener("DOMContentLoaded", function() {
	  setTimeout(function() {
	    if( !preloader.classList.contains('ready') )
	    {
	      preloader.classList.add('ready');
	      pageContent.classList.add('ready');
	      document.cookie = 'musikdk-preloader=seen;';
	    }
	  }, 2000)
	});

} else {

	preloader.parentNode.removeChild(preloader);
	pageContent.classList.add('ready');

}



function debounce(func, wait = 10, immediate = true) {
  let timeout;
  return function() {
    let context = this, args = arguments;
    let later = function() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    let callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
};

window.addEventListener('scroll', debounce(checkPosition));


let scrollPos = 0;
const nav = document.querySelector('.page__header');

function checkPosition() {
  let windowY = window.scrollY;
  if (windowY > scrollPos) {
    // Scrolling UP
    nav.classList.add('is-scrolled');
  } else {
    nav.classList.remove('is-scrolled');
  }
}

window.addEventListener('scroll', checkPosition);
window.addEventListener('load', checkPosition);




function scrollIt(destination, duration = 200, easing = 'linear', callback) {

  const easings = {
    linear(t) {
      return t;
    },
    easeInQuad(t) {
      return t * t;
    },
    easeOutQuad(t) {
      return t * (2 - t);
    },
    easeInOutQuad(t) {
      return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
    },
    easeInCubic(t) {
      return t * t * t;
    },
    easeOutCubic(t) {
      return (--t) * t * t + 1;
    },
    easeInOutCubic(t) {
      return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
    },
    easeInQuart(t) {
      return t * t * t * t;
    },
    easeOutQuart(t) {
      return 1 - (--t) * t * t * t;
    },
    easeInOutQuart(t) {
      return t < 0.5 ? 8 * t * t * t * t : 1 - 8 * (--t) * t * t * t;
    },
    easeInQuint(t) {
      return t * t * t * t * t;
    },
    easeOutQuint(t) {
      return 1 + (--t) * t * t * t * t;
    },
    easeInOutQuint(t) {
      return t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * (--t) * t * t * t * t;
    }
  };

  const start = window.pageYOffset;
  const startTime = 'now' in window.performance ? performance.now() : new Date().getTime();

  const documentHeight = Math.max(document.body.scrollHeight, document.body.offsetHeight, document.documentElement.clientHeight, document.documentElement.scrollHeight, document.documentElement.offsetHeight);
  const windowHeight = window.innerHeight || document.documentElement.clientHeight || document.getElementsByTagName('body')[0].clientHeight;
  const destinationOffset = typeof destination === 'number' ? destination : destination.offsetTop;
  const destinationOffsetToScroll = Math.round(documentHeight - destinationOffset < windowHeight ? documentHeight - windowHeight : destinationOffset);

  if ('requestAnimationFrame' in window === false) {
    window.scroll(0, destinationOffsetToScroll);
    if (callback) {
      callback();
    }
    return;
  }

  function scroll() {
    const now = 'now' in window.performance ? performance.now() : new Date().getTime();
    const time = Math.min(1, ((now - startTime) / duration));
    const timeFunction = easings[easing](time);
    window.scroll(0, Math.ceil((timeFunction * (destinationOffsetToScroll - start)) + start));

    if (window.pageYOffset === destinationOffsetToScroll) {
      if (callback) {
        callback();
      }
      return;
    }

    requestAnimationFrame(scroll);
  }

  scroll();
}




document.querySelector('.js-scroll').addEventListener('click', () => {
  scrollIt(
    document.querySelector('#arrangementer'),
    600,
    'easeOutQuad',
    () => console.log(`Just finished scrolling to ${window.pageYOffset}px`)
  );
});




//
// Store the DOM elements for the cookie functionality
// ===========================================================================

const cookieBar = document.querySelector( ".alert-cookie" );
const cookieBarButton = document.querySelector( ".alert-cookie button" );

//
// Description: Set cookie 'musikdk_cookie_consent' on button click, and sest expiry date to 90 days
// ===========================================================================

cookieBarButton.addEventListener( 'click', function() {
	setCookie( 'musikdk_cookie_consent', 'true', 90 );
});

//
// Based on the existance of the 'musikdk_cookie_consent', show/hide the cookie bar
// ===========================================================================

if( getCookie('musikdk_cookie_consent') === 'true'){
	cookieBar.classList.remove('show');
	cookieBar.classList.add('d-none');
} else {
	cookieBar.classList.add('show');
	cookieBar.classList.remove('d-none');
}
